import {UnreachableError} from '../../../../../libs/shared/helpers/src/types/customErrors';
import {
  DataFieldsTableColumnModel,
  DataFieldsTableColumnTypesEnum,
} from '../../../../models/api/dataFieldsTableModel';
import {ClientAtom, UninferredAtom} from '../expressionAtomModel';
import {ExpressionsContext} from '../expressionsContext';
import {ExpressionDependencies} from '../expressionState';
import {Method, MethodCategoriesEnum, ResultTypesEnum, UnknownResult} from './internal';

export class GetColumnValue extends Method {
  constructor() {
    super(MethodCategoriesEnum.TRANSFORM);
  }

  inferType(atom: UninferredAtom, context: ExpressionsContext, dependencies: ExpressionDependencies) {
    const column = getAtomColumn(atom, dependencies);
    if (!column) {
      return UnknownResult;
    }

    return {type: inferTableColumnExpressionType(column)};
  }

  getDefaultName(atom: ClientAtom, context: ExpressionsContext, dependencies: ExpressionDependencies) {
    const column = getAtomColumn(atom, dependencies);
    if (!column) {
      return undefined;
    }

    return column.name;
  }
}

function getAtomColumn(atom: UninferredAtom, dependencies: ExpressionDependencies) {
  if (!dependencies) {
    return undefined;
  }

  return dependencies.dataTable?.columns.find((column) => atom.params.column_id === column.id) ?? undefined;
}

export function inferTableColumnExpressionType(column: DataFieldsTableColumnModel): ResultTypesEnum {
  switch (column.type) {
    case DataFieldsTableColumnTypesEnum.CONTACT:
      return ResultTypesEnum.CONTACT;
    case DataFieldsTableColumnTypesEnum.NUMBER:
      return ResultTypesEnum.NUMBER;
    case DataFieldsTableColumnTypesEnum.STRING:
      return ResultTypesEnum.STRING;
    case DataFieldsTableColumnTypesEnum.TAG:
      return ResultTypesEnum.TAG;
    case DataFieldsTableColumnTypesEnum.BOOLEAN:
      return ResultTypesEnum.BOOLEAN;
    case DataFieldsTableColumnTypesEnum.TEAMMATE:
      return ResultTypesEnum.TEAMMATE;
    case DataFieldsTableColumnTypesEnum.INBOX:
      return ResultTypesEnum.INBOX;
    default:
      throw new UnreachableError(column.type);
  }
}
